<template>
    <div class="col-md-12 row">
        <div class="col-md-8">
      <input type="file" multiple @change="handleFileUpload" class="form-control"/> 
      </div>
      <div class="col-md-4">
      <button @click="uploadFiles" class="btn" style="background-color: #F49315; color: white;">Guardar Imagenes</button>
    </div>
    </div><br>
      <div v-if="images.length > 0" class="image-gallery">
        <div v-for="(image, index) in images" :key="index" class="image-item">
          <img :src="image.preview" :alt="'Image ' + (index + 1)" class="preview-image" width="600px"/>
          <button @click="removeImage(index)" class="remove-button">Eliminar</button>
        </div>
      </div>
      


  </template>
  
  <script>
    import { ref,onMounted } from 'vue';
    import axios from 'axios';
    import Swal from 'sweetalert2';

  export default {
    setup() {
      const images = ref([]);
  
      const handleFileUpload = (event) => {
        const files = event.target.files;
        if (files) {
          const newImages = Array.from(files).map(file => {
            return {
              file,
              preview: URL.createObjectURL(file)
            };
          });
          images.value.push(...newImages);
        }
      };
  
      const removeImage = (index) => {
        images.value.splice(index, 1);
      };
      const uploadFiles = async () => {
  const formData = new FormData();
  const idcotizacion = localStorage.getItem('idcotizacion');

  images.value.forEach(image => {
    formData.append('images[]', image.file); // Nota el cambio en el nombre del campo
  });
  formData.append('idcotizacion', idcotizacion);

  try {
    const response = await axios.post('https://backsarei.seguridadeninspeccion.com/api/guardarFotos', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    if(response.status == 200){
        Swal.fire('¡Éxito!', 'Imagen  importada', 'success');
    }
    else{
        Swal.fire('Error!', 'Imagen no importada', 'error');

    }
    
  } catch (error) {
    console.error('Error uploading files:', error.response ? error.response.data : error.message);
  }
};
const fetchImages = async () => {
      try {
        const idcotizacion = localStorage.getItem('idcotizacion');

        const response = await axios.post('https://backsarei.seguridadeninspeccion.com/api/consultarFotos',{idcotizacion:idcotizacion}); // Cambia esta URL a tu API
        if (response.status === 200) {
           
            response.data.data.forEach(a =>{
                var objeto = {
                    idcotizacion:a.idcotizacion,
                    preview:'https://backsarei.seguridadeninspeccion.com'+a.url_imagen
                };
                images.value.push(objeto);
            });
            console.log(images);
          //images.value = response.data.data; // Asegúrate de que la estructura de respuesta sea la esperada
        } else {
          console.error('Failed to fetch images:', response.statusText);
        }
      } catch (error) {
        console.error('Error fetching images:', error.response ? error.response.data : error.message);
      }
    };

    onMounted(() => {
      fetchImages();
    });
      return {
        images,
        handleFileUpload,
        removeImage,
        uploadFiles
      };
    }
  };
  </script>
  
  <style scoped>
  .image-gallery {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .image-item {
    position: relative;
    display: inline-block;
  }
  
  .preview-image {
    max-width: 150px;
    max-height: 150px;
    object-fit: cover;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  .remove-button {
    position: absolute;
    top: 5px;
    right: 5px;
    background: red;
    color: white;
    border: none;
    border-radius: 50%;
    cursor: pointer;
  }
  </style>
  